import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateTime from 'sharedWebpack/DateTime';
import Icon from '@wtag/rcl-icon';
import httpClient from 'agentHTTPClient';
import routes from 'agentRoutes';

import './styles.scss';

const Index = props => {
  const { journeyElementId, journeyElementType } = props;

  const [journeyElement, setJourneyElement] = useState({});

  const fetchJourneyElement = async () => {
    const { data } = await httpClient.get(
      routes.api.fetchJourneyElement({
        id: journeyElementId,
        type: journeyElementType,
      }),
    );

    setJourneyElement(data);
  };

  useEffect(() => {
    if (journeyElementId) {
      fetchJourneyElement();
    }
  }, [journeyElementId, journeyElementType]);

  const locationAndTime = (locationTimeObj, isStarts) => (
    <div className="col-6 col-bleed col-grid align-center event-item__details-info">
      <div>
        <div className="col-grid col-bleed event-item__details-info-header">
          {isStarts
            ? I18n.t('admin.components.orders.items_tab.placeholder.event_starts')
            : I18n.t('admin.components.orders.items_tab.placeholder.event_ends')}
        </div>
        <div className="col-grid col-bleed direction-row align-center event-item__details-info-time">
          <div className="event-item__details-info-time-icon">
            <Icon name="time" color="default" size="tiny" />
          </div>
          <div className="event-item__details-info-time-date">
            <DateTime format="shortWithTime" dateTime={locationTimeObj.localtimeInUserTz} />
          </div>
        </div>
        <div className="col-grid col-bleed direction-row align-center event-item__details-info-location">
          <div className="event-item__details-info-location-icon">
            <Icon name="mapMarker" size="tiny" color="danger" />
          </div>
          <div className="event-item__details-info-location-address">
            {locationTimeObj.location}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="col-12 event-item">
      <div className="event-item__header">
        <div className="event-item__header-name">{journeyElement.name}</div>
      </div>
      <div className="col-12 col-grid direction-row justify-space-between event-item__details">
        {journeyElement.starts && locationAndTime(journeyElement.starts, true)}
        {journeyElement.ends && locationAndTime(journeyElement.ends, false)}
      </div>
      <div className="col-grid col-bleed direction-row align-center justify-space-between event-item__footer">
        <div className="event-item__footer-facilities">
          {journeyElement.facilities &&
            I18n.t('admin.components.orders.items_tab.tag.facilities', {
              facilities: journeyElement.facilities,
            })}
        </div>
        <div className="event-item__footer-organizer">{journeyElement.organizer}</div>
      </div>
    </div>
  );
};

Index.propTypes = {
  journeyElementId: PropTypes.number.isRequired,
  journeyElementType: PropTypes.string.isRequired,
};

export default Index;
